var _rect, _path, _circle, _circle2, _rect2, _rect3, _rect4, _text, _rect5, _text2, _text3, _circle3, _path2, _rect6, _rect7, _path3, _path4, _path5, _text4, _text5, _rect8, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLynktopay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 48,
    fill: "#101114"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v760H0z",
    fill: "url(#grid)",
    opacity: 0.32
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 972,
    cy: 140,
    r: 220,
    fill: "#2DD4BF",
    opacity: 0.16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 615,
    r: 270,
    fill: "#FB7185",
    opacity: 0.14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 68,
    width: 424,
    height: 624,
    rx: 54,
    fill: "#0B1220",
    stroke: "rgba(255,255,255,.16)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 114,
    width: 352,
    height: 532,
    rx: 34,
    fill: "#121827"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 154,
    width: 166,
    height: 42,
    rx: 13,
    fill: "#2DD4BF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 485,
    y: 183,
    fill: "#101114",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 900
  }, "LynkToPay")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 230,
    width: 272,
    height: 116,
    rx: 24,
    fill: "rgba(45,212,191,.13)",
    stroke: "rgba(45,212,191,.42)",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 275,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 900
  }, "GHS 2,450")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 310,
    fill: "#CFEAE6",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "Verified payment record")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 692,
    cy: 288,
    r: 27,
    fill: "#2DD4BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m680 288 9 9 18-21",
    stroke: "#101114",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 378,
    width: 126,
    height: 108,
    rx: 22,
    fill: "rgba(255,255,255,.08)",
    stroke: "rgba(255,255,255,.13)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 378,
    width: 126,
    height: 108,
    rx: 22,
    fill: "rgba(255,255,255,.08)",
    stroke: "rgba(255,255,255,.13)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M509 435h36M527 417v36",
    stroke: "#2DD4BF",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M652 420h42v40h-42z",
    stroke: "#F59E0B",
    strokeWidth: 9,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M652 433h42",
    stroke: "#F59E0B",
    strokeWidth: 9
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 522,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 800
  }, "Orders")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 626,
    y: 522,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 800
  }, "Receipts")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 554,
    width: 272,
    height: 20,
    rx: 10,
    fill: "rgba(255,255,255,.12)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 554,
    width: 204,
    height: 20,
    rx: 10,
    fill: "#2DD4BF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 660,
    width: 170,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,.22)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 48,
    height: 48,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0v48",
    stroke: "white",
    strokeOpacity: 0.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLynktopay);
export default __webpack_public_path__ + "static/media/lynktopay.42ed7b464ac7382ba66e7f78fd2823be.svg";
export { ForwardRef as ReactComponent };